import { ConnectButton } from 'components/ConnectButton';
import { Body2 } from 'components/Typography';
import Link from 'next/link';
import { useContext } from 'react';
import { AccountInfo } from 'structure/Layouts/LayoutWithSideBar/AccountInfo';
import { AuthContext } from 'structure/providers/AuthProvider';
import { useClientRenderDelay } from 'utils/hooks/useClientRenderDelay';
import { useConnection } from 'wagmi';

export const ConnectInfoButton = () => {
  const { isConnected } = useConnection();
  const csr = useClientRenderDelay();
  const { dashboardInfo } = useContext(AuthContext);
  const { totalPoints } = dashboardInfo || {};

  return (
    <>
      {!csr && (
        <div className='rounded-main h-[38px] w-[148px] animate-pulse bg-[#191A1E]' />
      )}
      {csr && isConnected && (
        <>
          <Link href='/testnet/dashboard'>
            <Body2 className={`flex font-normal text-white-800 underline`}>
              {totalPoints || 0} points
            </Body2>
          </Link>
          <AccountInfo button={{ className: 'bg-[#191A1E]' }} />
        </>
      )}
      {csr && !isConnected && (
        <ConnectButton className='px-10 py-2 text-base' />
      )}
    </>
  );
};
